<template>
  <div class="medal-manager">
    <el-form :inline="true">
      <el-form-item label="行政区域等级:">
        <el-select
          style="width: 100px"
          clearable
          v-model="filters.deep"
          placeholder="请选择"
        >
          <el-option
            v-for="item in deepOptions"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="行政区名:">
        <el-input
          style="width: 170px"
          v-model="filters.extName"
          placeholder="请输入行政区名"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item style="margin-left: 20px">
        <toolbar
          :buttonList="buttonList"
          @callFunction="callFunction"
        ></toolbar>
      </el-form-item>
    </el-form>
    <!-- 
      关键属性：
      1. lazy: 开启懒加载模式
      2. load: 指定加载子数据的函数
      3. row-key: 唯一标识
      4. :tree-props: 配置子节点字段
    -->
    <el-table
      :data="tableData"
      style="width: 100%; margin-top: 20px"
      border
      highlight-current-row
      row-key="id"
      lazy
      :load="loadNode"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      class="custom-padding-table"
    >
      <el-table-column type="index" label="序号" align="left" width="80">
      </el-table-column>
      <el-table-column prop="extName" label="名称" align="left" min-width="200">
      </el-table-column>
      <el-table-column prop="extId" label="编码" align="left" min-width="200">
      </el-table-column>
    </el-table>
    <!--新增界面-->
    <el-dialog
      :title="editmark == true ? '编辑' : '新增'"
      :visible.sync="FormVisible"
      v-model="FormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="Form"
        label-width="100px"
        ref="Form"
        style="max-width: 700px"
        :rules="FormRules"
      >
        <el-form-item label="行政区名称：" prop="extName">
          <el-input
            v-model="Form.extName"
            auto-complete="off"
            placeholder="请输入号码库名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="编码:" prop="extId">
          <el-input
            v-model="Form.extId"
            auto-complete="off"
            placeholder="请输入编码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="FormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="FormSubmit"
          :loading="listLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAreaDictionaryList } from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      tableData: [],
      listLoading: false,
      editmark: false,
      FormVisible: false,
      //增删改查按钮
      buttonList: [],
      filters: {
        pid: 0,
        deep: null,
        extName: "",
      },
      Form: {
        extName: "",
        extId: "",
      },
      FormRules: {
        extName: [
          { required: true, message: "请输入行政区名称", trigger: "blur" },
        ],
        extId: [{ required: true, message: "请输入编码", trigger: "blur" }],
      },
      currentRow: null,
      deepOptions: [
        {
          id: 0,
          label: "省级",
        },
        {
          id: 1,
          label: "市级",
        },
        {
          id: 2,
          label: "县级",
        },
      ],
    };
  },
  methods: {
    handleSearch() {
      this.getList();
    },
    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },

    loadNode(row, treeNode, resolve) {
      console.log("row", row);
      const pid = row ? row.id : 0;
      getAreaDictionaryList({
        pid: pid,
      })
        .then((res) => {
          if (res.data.success) {
            let childrenData = res.data.response;
            childrenData = childrenData.map((item) => {
              const hasChild = item.deep < 2;
              return {
                ...item,
                hasChildren: hasChild, // 显式添加该字段
              };
            });
            resolve(childrenData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    },

    getList() {
      this.listLoading = true;
      if (this.filters.deep==0||this.filters.deep==1||this.filters.deep==2) {
        this.filters.pid = null;
      }
      getAreaDictionaryList({
        ...this.filters,
      }).then((res) => {
        this.listLoading = false;
        if (res.data.success) {
          this.tableData = res.data.response;
        }
      });
    },
    handleAdd() {
      this.Form = {
        extName: "",
        extId:""
      };
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.clearValidate();
        }
      });
      this.editmark = false;
      this.FormVisible = true;
    },
    handleEdit() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.clearValidate();
        }
      });
      this.Form = {
        extName: this.currentRow.extName,
        extId:this.currentRow.extId
      
      };
      this.editmark = true;
      this.FormVisible = true;
    },
    selectCurrentRow(row) {
      console.log("row", row);
      this.currentRow = row;
    },
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="stylus" scoped>
.medal-manager {
  padding: 20px;
  background-color: #fff;
}

/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table {
  ::v-deep .el-table__cell {
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px;
    padding-bottom: 16px;
  }

  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
}

/* 👆👆👆 新增的样式结束 👆👆👆 */
</style>